export const Testimonials = (props) => {
  return (
    <div id='testimonials'>
      <div className='container'>
        <div className='section-title text-center'>
          <h2>What do our users say?</h2>
        </div>
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className='col-md-4'>
                  <div className='testimonial'>
                    <div className='testimonial-image'>
                      {' '}
                      <img src={d.img} alt='' />{' '}
                    </div>
                    <div className='testimonial-content'>
                      <p>"{d.text}"</p>
                      <div className='testimonial-meta'> - {d.name} </div>
                    </div>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>

        <div className='cc-testimonial-proof-row text-center'>
          <hr className='cc-divider' />
          <div className='cc-testimonial-proof-logos mt-3 mb-4'>
            <img src='img/wendyLogo.png' alt="Wendy's" className='cc-testimonial-proof-logo' />
            <img src='img/wenventurelogo.png' alt='Wen Venture' className='cc-testimonial-proof-logo' />
            <img src='https://www.chiplocked.com/img/Chip-locked-images/LOGOcircle2.png' alt='Chip Locked' className='cc-testimonial-proof-logo' />
          </div>
        </div>
      </div>
    </div>
  )
}
